import { compose } from 'redux';
import { connect } from 'react-redux';

import { openModal as openModalAction } from 'components/Modal';
import { withForm } from 'components/Form';
import { SmartSpotStatus, updateSmartSpot as updateSmartSpotAction } from 'components/SmartSpot';

import { SMARTSPOT_REASON } from 'constants/logic';

const FORM_NAME = 'CLASS_SMART_SPOT_TOGGLE';

const mapStateToProps = (state, { isEnabled, schedule }) => {
  return {
    initialValues: {
      smartspotEnabled: isEnabled,
    },
    schedule,
  };
};

const mapDispatchToProps = {
  openModal: openModalAction,
  updateSmartSpot: updateSmartSpotAction,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { schedule, canOnlyToggleNonRecurring } = ownProps;
  const { openModal, updateSmartSpot } = dispatchProps;
  const { reset } = ownProps;

  const handleEnableSmartSpotWithoutConfirmation = smartspotEnabled => {
    const { venueId, scheduleClass, scheduleId, scheduleName: className, startDateTime } = schedule;
    const { classId } = scheduleClass || {};
    const data = {
      isEnabled: smartspotEnabled,
    };
    const meta = {
      classId,
      className,
      isModal: false,
      reason: SMARTSPOT_REASON.SCHEDULE_SETTING,
      scheduleId,
      startDateTime,
      venueId,
    };

    updateSmartSpot(data, meta);
  };

  const handleSmartSpotToggleSubmit = smartspotEnabled => {
    if (smartspotEnabled && canOnlyToggleNonRecurring) {
      handleEnableSmartSpotWithoutConfirmation(smartspotEnabled);
    } else {
      openModal('ManageSmartSpotModal', {
        schedule: { ...schedule, smartspotEnabled, canOnlyToggleNonRecurring },
        onClose: () => reset(FORM_NAME),
      });
    }
  };

  return {
    ...stateProps,
    ...ownProps,
    onSubmit: smartspotEnabled => handleSmartSpotToggleSubmit(smartspotEnabled),
  };
};

export default compose(
  connect(mapStateToProps),
  withForm({
    form: FORM_NAME,
    enableReinitialize: true,
  }),
  connect(null, mapDispatchToProps, mergeProps)
)(SmartSpotStatus);
